// extracted by mini-css-extract-plugin
export var createdDate = "_fh-1";
export var divider = "_fh-2";
export var headerDivider = "_fh-3";
export var messagesCard = "_fh-0";
export var messagesContainer = "_fh-6";
export var messagesContainerWrapper = "_fh-4";
export var showLeftPanelButton = "_fh-8";
export var topButtons = "_fh-7";
export var withPadding = "_fh-5";